









// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { AloProfilExclusion, getDefaultAloProfilExclusion } from '@/models/alo/AloProfilExclusion';

@Component({
  name: 'EditBaseProfilExclusion',    
  components:{EditDrawer},
  props: {
    title:String,            
    width:{
      type:String,
      default:"1200"
    },
    saveLabel:{
      type:String,
      default:"Sauvegarder"
    }
  } 
})
export default class EditBaseProfilExclusion extends Vue {
  
  private original = getDefaultAloProfilExclusion()
  private modified = getDefaultAloProfilExclusion()
  private showDrawer = false
  private saving = false 

  edit(item:AloProfilExclusion) {        
    this.$store.myActions.ADM_PROFIL_EXCLUSION_RESET_STATUS()
    this.showDrawer = true
    this.original = item
    this.modified = cloneDeep(item) 

    return this.modified   
  }  

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get profilExclusionStatus() {
    return this.$store.myGetters.profilExclusionStatus        
  }

  saveData() {    
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.saving = true
      this.$store.myActions.ADM_PROFIL_EXCLUSION_SAVE_REQUEST(this.modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.profilExclusionStatus)          
        this.showDrawer = false
      }).finally(()=>{
        this.saving = false
      })    
    } 
  }

  
}
